<script setup lang="ts">
const { org, urlBase } = useContext()

const { $getPathFor } = useNuxtApp()
const { t } = useI18n()

const groupsLinks = computed(() => {
  return org.groups?.filter(group => !group.is_cup_group).map(group => ({
    label: group.name,
    to: $getPathFor(`groups/${group.slug}`, urlBase),
  }))
})

const cupGroupsLinks = computed(() => {
  return org!.groups?.filter(group => group.is_cup_group).map(group => ({
    label: group.name,
    to: $getPathFor(`cup/${group.slug}`, urlBase),
  }))
})

const links = [
  {
    label: t('Home'),
    to: $getPathFor('/', urlBase),
  },
  {
    label: t('About'),
    items: [
      {
        label: t('Board Members'),
        to: $getPathFor('board-members', urlBase),
      },
      {
        label: t('Documents'),
        to: $getPathFor('documents', urlBase),
      },
      {
        label: t('Help'),
        to: $getPathFor('help', urlBase),
      },
    ],
  },
  {
    label: t('Calendar'),
    to: $getPathFor('calendar', urlBase),
  },
  {
    label: t('Individual'),
    to: $getPathFor('individual', urlBase),
  },
  {
    label: t('Ranking'),
    items: groupsLinks.value,
  },
  {
    label: t('Cup'),
    items: cupGroupsLinks.value,
  },
  {
    label: t('Captain Login'),
    target: '_blank',
    to: 'https://darts-competitie.be',
    highlight: true,
  },
]
</script>

<template>
  <MenuBar
    :model="links"
    class="z-200"
    :class="{ 'bg-(--p-surface-0) dark:bg-(--p-surface-900)': org.theme === 'lara' }"
  >
    <template #start>
      <NuxtLink
        :to="$getPathFor('/', urlBase)"
        class="flex flex-row gap-2 items-center"
      >
        <NuxtImg
          v-if="org.logo"
          :src="org.logo"
          :alt="org.name"
          width="100"
          height="100"
        />
        <span class="text-xl font-bold">{{ org.name }}</span>
      </NuxtLink>
    </template>

    <template #item="{ item, hasSubmenu }">
      <NuxtLink
        class="flex items-center p-menubar-item-link"
        active-class="bg-(--p-menubar-item-active-background) text-(--p-menubar-item-active-color)"
        :class="{ 'font-bold': item.highlight }"
        :to="item.to"
        :target="item.target"
      >
        <span>
          {{ item.label }}
        </span>
        <Icon
          v-if="hasSubmenu"
          name="tabler:chevron-down"
        />
        <Icon
          v-if="item.highlight"
          name="tabler:square-rounded-arrow-right"
        />
      </NuxtLink>
    </template>
  </MenuBar>
</template>

<style>
.p-menubar {
  justify-content: space-between;
}
</style>
